export type FeatureFlagType = {
  DISABLED_UNLOCK_WHEN_CHECKED_IN?: boolean;
  MEMBER_APP_CHECK_IN?: boolean;
  PORTAL_XERO?: boolean;
  NEW_MEMBERS_APP_HOME?: boolean;
  NEW_MEMBERS_APP_ACCESS?: boolean;
  NEW_MEMBERS_APP_PROFILE_TAB?: boolean;
  NEW_MEMBERS_APP_NEW_BOOKINGS_SCREENS?: boolean;
  PORTAL_NEW_STAFF_SIDEBAR?: boolean;
  PORTAL_NEW_REPORTS_DATE_PICKER?: boolean;
  FE_VOUCHER_CHECKOUT?: boolean;
  PORTAL_KISI_INTEGRATION?: boolean;
  FE_USER_WALLETS?: boolean;
  MEMBER_APP_HOME_PAGE_CUSTOMIZATION?: boolean;
};

const globalFeatureFlagOverride: FeatureFlagType = {
  NEW_MEMBERS_APP_HOME: true,
  NEW_MEMBERS_APP_ACCESS: true,
  PORTAL_KISI_INTEGRATION: true,
};

export const featureFlagOverrideMap = {
  portal: globalFeatureFlagOverride,
  memberApp: globalFeatureFlagOverride,
  staffApp: globalFeatureFlagOverride,
} as const;
